import { myExamsRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { createRoute } from "@/routes/utils";
import { IRoleEnum } from "@/interfaces";

const permission = [IRoleEnum.Student];

const myExamsRouteMetadata: IRouteMetadataObj<typeof myExamsRoutesObj> = {
  list: {
    title: "myExams.index.title",
    description: "myExams.index.description",
    lazy: () => import("@/pages/studentPages/myTrainingCourseExams/table/page"),
    mode: "index",
    type: "main",
    icon: "FileEditLine",
    breadcrumbs: [],
    permission,
  },
  view: {
    title: "myExams.view.title",
    description: "myExams.view.description",
    lazy: () => import("@/pages/studentPages/myTrainingCourseExams/view/page"),
    mode: "view",
    type: "inner",
    isPageFullMode: true,
    icon: "FileEditLine",
    breadcrumbs: [],
    permission,
  },
  showOnline: {
    title: "myExams.start.title",
    description: "myExams.start.description",
    lazy: () => import("@/pages/studentPages/showOnlineExam/view/page"),
    mode: "create",
    type: "inner",
    icon: "FileEditLine",
    breadcrumbs: [],
    permission,
  },
  startOnlineMultipleChoice: {
    title: "myExams.start.title",
    description: "empty",
    lazy: () =>
      import(
        "@/pages/studentPages/startOnlineExam/multipleChoiceQuestions/form/page"
      ),
    mode: "create",
    type: "inner",
    icon: "FileEditLine",
    breadcrumbs: [],
    isPageFullMode: true,
    permission,
  },
  startOnlineBinary: {
    title: "myExams.start.title",
    description: "empty",
    lazy: () =>
      import("@/pages/studentPages/startOnlineExam/trueOrFalseQuestions/page"),
    mode: "create",
    type: "inner",
    icon: "FileEditLine",
    breadcrumbs: [],
    isPageFullMode: true,
    permission,
  },
  showDescriptive: {
    title: "myExams.start.title",
    description: "myExams.start.description",
    lazy: () => import("@/pages/studentPages/showDescriptiveExam/view/page"),
    mode: "create",
    type: "inner",
    icon: "FileEditLine",
    breadcrumbs: [],
    permission,
  },
  startDescriptive: {
    title: "myExams.descriptiveExam.title",
    description: "empty",
    lazy: () => import("@/pages/studentPages/startDescriptiveExam/form/page"),
    mode: "create",
    type: "inner",
    icon: "FileEditLine",
    breadcrumbs: [],
    permission,
  },
  submitResultOnline: {
    title: "myExams.submit.title",
    description: "myExams.submit.description",
    lazy: () => import("@/pages/studentPages/submitTheResult/online/form/page"),
    mode: "create",
    type: "inner",
    icon: "FileEditLine",
    breadcrumbs: [],
    permission,
  },
  submitResultDescriptive: {
    title: "myExams.submit.title",
    description: "empty",
    lazy: () =>
      import("@/pages/studentPages/submitTheResult/descriptive/form/page"),
    mode: "create",
    type: "inner",
    icon: "FileEditLine",
    breadcrumbs: [],
    permission,
  },
  showOnlineExamScore: {
    title: "myExams.showScore.title",
    description: "myExams.showScore.description",
    lazy: () => import("@/pages/studentPages/showTheScore/online/view/page"),
    mode: "view",
    type: "inner",
    icon: "FileEditLine",
    breadcrumbs: [],
    permission,
  },
  checkOnlineExamScore: {
    title: "myExams.correctAnswers.title",
    description: "myExams.correctAnswers.description",
    lazy: () => import("@/pages/studentPages/showTheScore/online/view/page"),
    mode: "view",
    type: "inner",
    icon: "FileEditLine",
    breadcrumbs: [],
    permission,
  },
  checkOnlineExamQuestionDescription: {
    title: "myExams.answerDescription.title",
    description: "empty",
    lazy: () => import("@/pages/studentPages/answerDescription/view/page"),
    mode: "view",
    type: "inner",
    icon: "FileEditLine",
    breadcrumbs: [],
    permission,
  },
  showDescriptiveExamScore: {
    title: "myExams.examResults.title",
    description: "myExams.examResults.description",
    lazy: () =>
      import("@/pages/studentPages/showTheScore/descriptive/view/page"),
    mode: "view",
    type: "inner",
    icon: "FileEditLine",
    breadcrumbs: [],
    permission,
  },
};

export const myExamsRoutes = createRoute<typeof myExamsRoutesObj>(
  myExamsRoutesObj,
  myExamsRouteMetadata,
);
